import React from 'react';
import Icon from '@ant-design/icons';
import { Col, Row } from 'antd';
import { Link } from 'react-router-dom';
import { routerPath } from '../../router/routerPath';
import { CustomCol } from '../../styles/styled';
import { FooterLink, FooterText, LkFooterContainer } from './styled';

export const LkFooterComponent = () => {
  return (
    <LkFooterContainer>
      <Row style={{ width: '100%' }} justify="space-between" align="top" wrap>
        <CustomCol flexdirection="row">
          <Link to={routerPath.mainpage}>
            <Icon component={() => <img src="/icons/footerlogo.svg" alt="footer" />} />{' '}
          </Link>
          <Link to={routerPath.mainpage}>
            <h1>ФЕДЕРАЛЬНЫЙ ПЕРЕЧЕНЬ УЧЕБНИКОВ</h1>
          </Link>
        </CustomCol>
        <Col>
          <FooterLink to="/">Федеральный перечень учебников</FooterLink>
        </Col>
        <Col>
          <FooterLink to={routerPath.listOfOrganisations}>Перечень организаций</FooterLink>
        </Col>
        <Col>
          <FooterText>
            Служба технической <br />
            поддержки
          </FooterText>
        </Col>
        <CustomCol flexdirection="column">
          <div className="text">Тел: +7 (499) 681 03 85</div>
          <div className="text">
            email: <a href="mailto:fpu.support@ficto.ru">fpu.support@ficto.ru</a>
          </div>
          <div className="text">пн.-пт. с 9:00 до 18:00 по МСК</div>
        </CustomCol>
      </Row>
    </LkFooterContainer>
  );
};
